import React from 'react';
import styles from './style.module.scss';
import { withThemeVariant } from '../../provider/ThemeProvider/index';

var Header = function Header(_ref) {
  var children = _ref.children,
      globalThemeVariant = _ref.globalThemeVariant;
  return React.createElement("div", {
    className: styles.headerPc
  }, React.createElement("div", {
    className: styles.childrenWrapper
  }, children), React.createElement("div", {
    className: styles.layer
  }));
};

export default withThemeVariant(Header);